import React from 'react';
import { connect } from 'react-redux';
import 'app/shared/modules/mobile-apps/MobileAppsHero.scss';
import Container from 'app/shared/core/Container';
import Section from 'app/shared/modules/Section';
import Row from 'app/shared/core/Row';
import Title from 'app/shared/modules/Title';
import MobileAppLink from 'app/shared/modules/mobile-apps/MobileAppLink';
import type { RootReduxState } from 'app/shared/flux/reducers';

type MobileAppsHeroProps = {
  deviceType?: string;
};

class MobileAppsHero extends React.Component<MobileAppsHeroProps> {
  render() {
    return (
      <section className="MobileHero">
        <Container>
          <Section>
            <Title size="lg">HotPads mobile</Title>
          </Section>
          <Section>
            <Row className="MobileHero-badges">
              <MobileAppLink adgroup="mobilePage" device="ios" />
              <MobileAppLink adgroup="mobilePage" device="android" />
            </Row>
            <Row>
              <Title size="md">HotPads mobile apps</Title>
              <p>We have mobile apps on:</p>
              <ul>
                <li>iPhone</li>
                <li>iPad</li>
                <li>Phones</li>
                <li>Tablets</li>
              </ul>
            </Row>
          </Section>
          <Section>
            <div className="MobileAppsHero-device-image" />
          </Section>
        </Container>
      </section>
    );
  }
}

const mapStateToProps = (state: RootReduxState) => {
  return {
    deviceType: state.app.device.deviceType,
  };
};

export default connect(mapStateToProps)(MobileAppsHero);
